import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { localizedPath } from 'gatsby-theme-i18n/src/helpers';
import { navigate } from 'gatsby';

import styled from 'styled-components';

const ARROW_SIZE = 15;
const ARROW_OUTER_GAIN = 3;
const ARROW_INNER_GAIN = 1;
const BORDER_WIDTH = 3;

const SubmenuContainer = styled.div`
  display: flex;
  background-color: var(--color-white);
  border: solid var(--color-white) ${BORDER_WIDTH}px;
  position: absolute;
  left: ${(props) => Math.floor(props.position)}px;
  z-index: 1000;
  width: 350px;
  box-sizing: border-box;
  max-height: calc(100vh - 130px);
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.25);
`;

const MenuItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-teal);
  width: 100%;
  overflow-y: auto;

  & a {
    text-decoration: none;
    color: var(--color-white);  
  }

  & h4 {
    margin: 0;

    & p {
      font-size: 17px;
      margin: 0;
      padding: 15px 25px;
      cursor: pointer;
      white-space: pre-wrap;
    }
  }
`;

const MenuItems = styled.div`
  display: flex;
  flex-direction: column;

  &:hover {
    cursor: pointer;
    color: var(--color-white);
    background-color: var(--color-teal);
  }

  &:first-child {
    margin-top 10px;
  }

  &:last-child {
    margin-bottom 10px;
  }
`;

const ArrowContainer = styled.div`
  position: absolute;
  top: -${ARROW_SIZE}px;
  left: ${(props) => Math.floor(props.position - ARROW_SIZE - (ARROW_OUTER_GAIN / 2))}px;
  width: ${(ARROW_SIZE * 2) + ARROW_OUTER_GAIN}px;
  height: ${ARROW_SIZE}px;
`;

const OuterTriangle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(ARROW_SIZE * 2) + ARROW_OUTER_GAIN}px;
  height: ${ARROW_SIZE}px;
  box-sizing: border-box;
  border-left: ${ARROW_SIZE}px solid transparent;
  border-bottom: ${ARROW_SIZE}px solid var(--color-white);
  border-right: ${ARROW_SIZE}px solid transparent;
`;

const InnerTriangle = styled.div`
  position: absolute;
  top: ${BORDER_WIDTH}px;
  left: ${BORDER_WIDTH + ((ARROW_OUTER_GAIN - ARROW_INNER_GAIN) / 2)}px;
  width: ${((ARROW_SIZE - BORDER_WIDTH) * 2) + ARROW_INNER_GAIN}px;
  height: ${ARROW_SIZE - BORDER_WIDTH}px;
  box-sizing: border-box;
  border-left: ${ARROW_SIZE - BORDER_WIDTH}px solid transparent;
  border-bottom: ${ARROW_SIZE - BORDER_WIDTH}px solid var(--color-white);
  border-right: ${ARROW_SIZE - BORDER_WIDTH}px solid transparent;
`;

export default class Submenu extends Component {
  static propTypes = {
    subpages: PropTypes.arrayOf(PropTypes.object),
    menuPosition: PropTypes.number,
    arrowPosition: PropTypes.number,
    locale: PropTypes.string,
    data: PropTypes.object,
  };

  render() {
    const {
      subpages, menuPosition, arrowPosition, locale, data,
    } = this.props;

    return (
      <SubmenuContainer className="submenu" position={menuPosition}>
        <ArrowContainer position={arrowPosition}>
          <OuterTriangle />
          <InnerTriangle />
        </ArrowContainer>
        <MenuItemContainer>
          {subpages?.map((item, index) => (
            <MenuItems
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              onClick={() => {
                navigate(localizedPath({
                  locale,
                  path: `/${data?.node?.frontmatter?.urlPath}/${item?.node?.frontmatter?.title}`,
                  defaultLang: 'de',
                  prefixDefault: false,
                }));
              }}
            >
              <h4>
                <MDXRenderer>{item?.node?.frontmatter?.submenuSubheadline}</MDXRenderer>
              </h4>
            </MenuItems>
          ))}
        </MenuItemContainer>
      </SubmenuContainer>
    );
  }
}
